// extracted by mini-css-extract-plugin
export default {"option":"doctorSelect_option__dXmHN","name":"doctorSelect_name__8zF7s","specialty":"doctorSelect_specialty__9n234","select_props":"doctorSelect_select_props__BWE7l"};